var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthView',{attrs:{"form":_vm.FORM_CONFIG,"formLoading":_vm.loading},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }